<template>
    <div>
        <template v-if="transaction_fee === true">
            <div class="page-top mb-3 mt-3 clearfix">
                <router-link to="/addCompanyWiseTransactionFeeComponent" class="btn btn-primary active float-right"> Add </router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" companyName="" />
                </div>
            </div>
            <table id="TransactionFeeTable" class="table" width="100%">
                <thead>
                <tr>
                    <th>Company</th>
                    <th>Transaction Type</th>
                    <th>Fee Type</th>
                    <th>Fee</th>
                    <th>Max Charge</th>
                    <th>Status</th>
                    <th class="text-center">Action</th>
                </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="transaction_fee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="transaction_fee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                transaction_fee: null
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var TransactionFeeTable = $('#TransactionFeeTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/listTransactionFee",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'companyName'},
                        {data: 'transactionType'},
                        {data: 'feeType'},
                        {data: 'fee'},
                        {data: 'maxCharge'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = '/editCompanyWiseTransactionFeeComponent/'+full['id'];
                                return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        TransactionFeeTable.search(this.value).draw();
                    }
                });
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('transaction_fee').then(result => {
                this.transaction_fee = result.transaction_fee;
            }).then(result => {
                if(this.transaction_fee == true){
                    this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
